import api from "./api";
import { toast } from "react-toastify";
class BpService {
  async getBranches() {
    try {
      const response = await api.get(`/bp/branches/`).then((res) => res.data);
      if (response.success) {
        return response.response;
      } else throw new Error(response.response);
    } catch (ex) {
      toast.error(ex.message);
      console.log(ex);
      return false;
    }
  }
}

const bpService = new BpService();
export default bpService;
